import { render, staticRenderFns } from "./ItemFilter.vue?vue&type=template&id=d4b20d14"
import script from "./ItemFilter.vue?vue&type=script&lang=js"
export * from "./ItemFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports